import { PROGRAMS } from '../constants';
import SectionLabel from './section-label';

const colorClasses = [
  'bg-hub-mint text-hub-forest md:col-span-2',
  'bg-hub-sky text-hub-forest',
  'bg-hub-peach text-hub-forest',
  'bg-hub-lavender text-hub-forest md:col-span-2',
];

function ProgramsSection() {
  return (
    <section id="programs" className="bg-hub-cream px-5 py-20 md:py-28">
      <div className="mx-auto max-w-7xl">
        <SectionLabel eyebrow="Programs" title="Outreach designed for confidence, contribution, and connection." align="center" />
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {PROGRAMS.map((program, index) => (
            <article key={program.title} className={`rounded-[2rem] p-7 shadow-soft ${colorClasses[index]}`}>
              <p className="text-xs font-black uppercase tracking-[0.24em] opacity-70">0{index + 1}</p>
              <h3 className="mt-8 font-display text-3xl font-bold">{program.title}</h3>
              <p className="mt-5 text-lg leading-8 opacity-80">{program.summary}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProgramsSection;
